
export default {
  // Profile
  "profile_reviews": "Bewertungen",
  "profile_no_reviews": "Noch keine Bewertungen",
  "profile_share_experience": "Teilen Sie Ihre Erfahrung mit der Filmgemeinschaft!",
  "verified_traveler": "Verifizierter Reisender",
  "verified_creative": "Verifizierter Kreativschaffender",
  "verified_traveler_tooltip": "Dieser Benutzer ist ein verifizierter Reisender",
  "verified_creative_tooltip": "Verifizierter Fotograf oder Kreativprofi",
  "favorite_airports": "Lieblings-Flughäfen",
  "no_favorite_airports": "Noch keine Lieblings-Flughäfen",
  "user_favorites": "Benutzerfavoriten",
  "manage_favorites": "Favoriten verwalten"
};
